import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@webapp/auth';
import { QUOTER_ROUTE_PATH } from '@webapp/core';

export const clientAuthGuard: CanActivateFn = () => {
  if (!inject(AuthService).isAuthenticated()) {
    inject(Router).navigate([QUOTER_ROUTE_PATH]);
    return false;
  }
  return true;
};
